import React from "react";
import loadingGif from "../../assets/images/logoLoading.gif";

const PageLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <img className="max-w-sm md:w-40" src={loadingGif} alt="loading" />
    </div>
  );
};

export default PageLoading;
